import type {
  FetchArgs,
  FetchBaseQueryError,
  QueryReturnValue,
} from "@reduxjs/toolkit/query";

import { createQueryFn } from "./create-query-fn";
import { rtkqFetchAllPages } from "./rtkq-fetch-all-pages";

export function pagedQueryFn<TDto, TResult, TArg = void>(
  request: FetchArgs | ((arg: TArg) => FetchArgs),
  transformData: (dtos: TDto[], arg: TArg) => TResult,
  pageSize?: number
) {
  return createQueryFn<
    TArg,
    Promise<QueryReturnValue<TResult, FetchBaseQueryError, undefined>>
  >((arg, executeBaseQuery) => {
    const resolvedRequest = typeof request === "function" ? request(arg) : request;
    return rtkqFetchAllPages<TDto, TResult>(
      executeBaseQuery,
      resolvedRequest,
      (dtos) => transformData(dtos, arg),
      pageSize
    );
  });
}
